import React from 'react';
import { SignInFlow } from '@boller002/auth';
import auth from '../auth';
import config from '../config';

const Login = ({ onLogin }) => (
  <SignInFlow auth={auth} appName={config.appName} onSignedIn={onLogin} />
);

export default Login;
